/*
|-------------------------------------------------------------------------------
| Mixins for general methods applied accross multiple components/pages.
|-------------------------------------------------------------------------------
*/
import strapiServices from '../services/StrapiServices';
import * as helpers from "../utilities/helperUtils";

export default {
    data() {
        return {
            newsArticles: [],
            imageGallery: [],
            lightBoxSources: [],
        };
    },
    computed: {
        mainUrl() {
            let baseUrl = window.location.origin;
            let strapiUrl = "";
            if (baseUrl.includes("develop")) {
                strapiUrl = "https://devstrapi.hermertiawars.com"
            } else if (baseUrl.includes("hermertiawars.com") && !baseUrl.includes("develop")) {
                strapiUrl = "https://strapi.hermertiawars.com"
            } else {
                strapiUrl = helpers.getEnvironmentVar("VUE_APP_STRAPI_URL", "");
            }
    
            return strapiUrl;
        }
    },
    methods: {
        getArticles(sourceData) {
            let articles = sourceData.data;
            articles.sort(function compare(a, b) {
                var dateA = new Date(a.createdAt);
                var dateB = new Date(b.createdAt);
                return dateB - dateA;
            });

            if (this.mainUrl) {
                articles.forEach((imgEl) => {
                    let oldURL = imgEl.coverImg.url;
                    let newUrl = this.mainUrl + oldURL.replace(/^.*\/\/[^\/]+/, '');
                    imgEl.coverImg.url = newUrl;
                });
            }

            return articles;
        }
    }
};
